import { AppState } from 'app/store';

export const getCSV = (state: AppState) => state.import.csv;

export const getImportSongs = (state: AppState) => state.import.songs || [];

export const getImportStatus = (state: AppState) => {
  return state.import.status;
};
